;(function ($) {

	'use strict';

	function getParams(url) {
		
		var params = filterDefaults; //default

		var parser = document.createElement('a');
		parser.href = url;
		var query = parser.search.substring(1);
		var vars = query.split('&');
		for (var i = 0; i < vars.length; i++) {

			if (vars[i] == '') {
				return;
			}

			var pair = vars[i].split('=');
			params[pair[0]] = decodeURIComponent(pair[1]);
		}
		return params;
	}

	var $filter = $('#filter');
	if ($filter.length) {

		var $posts = $('#results-container').find('.card');
		var $themes = $('#results-container').find('.theme');
		var $notFound = $('#restulsNotFound');

		var numberOfHiddenPostsGlobal = 0;

		var params = getParams(window.location);
		if (params) {
			setFilterControls(params);
		}
	
		var $filterTypes = $('#filterTypes input');
		$filterTypes.on('change', function(e) {

			// $('body').addClass('waiting-for-load');
			filterValues.type = $(this).val();
			// $(document).trigger('customFilter:updated');
		
		});

		var $filterCategories = $('#filterCategories input');
		$filterCategories.on('change', function(e) {

			// $('body').addClass('waiting-for-load');
			filterValues.category = $(this).val();
			// $(document).trigger('customFilter:updated');
		
		});

		var $filterTags = $('#filterTags input');
		$filterTags.on('change', function(e) {

			// $('body').addClass('waiting-for-load');
			filterValues.tags = $(this).val();
			// $(document).trigger('customFilter:updated');
		
		});

		var $button = $('#filterSubmit');
		$button.on('click', function(e) {

			$('body').addClass('waiting-for-load');

			filterPosts();

			$('body').removeClass('waiting-for-load');

		});

		function filterPosts() {

			numberOfHiddenPostsGlobal = 0;

			setPosts();
			setThemes();

			console.log(numberOfHiddenPostsGlobal);

			$notFound.addClass('d-none');
			if (numberOfHiddenPostsGlobal == $posts.length) {
				$notFound.removeClass('d-none');
			}

			$('body').removeClass('filter-active');
		}

		function setPosts() {

			for (var i = 0; i < $posts.length; i++) {

				var $post = $($posts[i]);
				var $parent = $post.parent();
				var hidden = false;

				if (filterValues.type !== 'all' && $post.attr('data-type') !== filterValues.type) {
					$parent.addClass('d-none');
					hidden = true;
				}

				if (filterValues.category !== 'all' && $post.attr('data-category') !== filterValues.category) {
					$parent.addClass('d-none');
					hidden = true;
				}

				if (filterValues.tags !== 'all' && !$post.attr('data-tags').includes(filterValues.tags)) {
					$parent.addClass('d-none');
					hidden = true;
				}

				if (!hidden) {
					$parent.removeClass('d-none');
				}
				else {
					numberOfHiddenPostsGlobal++;
				}

			}
			
		}

		function setThemes() {

			for (var i = 0; i < $themes.length; i++) {
				var $theme = $($themes[i]);
				var numberOfPosts = parseInt($theme.attr('data-posts')); 
				var numberOfHiddenPosts = $theme.find('.postWrap.d-none').length;

				if (numberOfHiddenPosts == numberOfPosts) {
					$theme.addClass('d-none');
				}
				else {
					$theme.removeClass('d-none');
				}
			}

		}

		function setFilterControls(params) {

			filterValues.type = params.type;
			filterValues.category = params.category;
			filterValues.tags = params.tags;

			$('#filterTypes').find('input[value="' + filterValues.type + '"').prop('checked', true);
			$('#filterCategories').find('input[value="' + filterValues.category + '"').prop('checked', true);
			$('#filterTags').find('input[value="' + filterValues.tags + '"').prop('checked', true);

			filterPosts();
		}

		var $buttonReset = $('#filterReset');
		$buttonReset.on('click', function(e) {

			$('body').addClass('waiting-for-load');

			filterValues = {
				'type': 'all',
				'category': 'all',
				'tags': 'all'
			};
			
			setFilterControls(filterValues);
			filterPosts();

			$('body').removeClass('waiting-for-load');

		});

		$('#filterToggle').on('click', function(e) {
			e.preventDefault();      
      $('body').toggleClass('filter-active');
		});
	
		// function reset() {

		// 	$('body').addClass('waiting-for-load');

		// 	filterValues.category = filterValuesDefault.category;
		// 	filterValues.type = filterValuesDefault.type;
		// 	filterValues.min = filterValuesDefault.min;
		// 	filterValues.max = filterValuesDefault.max;
		// 	filterValues.limit = filterValuesDefault.limit;

		// 	// set category
		// 	setCategory(filterValues.category);

		// 	// set type
		// 	setPosts(filterValues.type);

		// 	// set time slider
		// 	slider.noUiSlider.set([filterValues.min, filterValues.max]);

		// 	setRecipes();
		// }

		// $('#recipesReset').on('click', reset);
	
		// $(document).on('customFilter:updated', function(e) {
		// 	// getFilterValues();
	
		// 	// show filtered recipes

		// 	setRecipes();
		// });

		// reset();

	}



})(jQuery);